
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/certifications/[certificationSlug]/recommended-course-plan",
      function () {
        return require("private-next-pages/certifications/[certificationSlug]/recommended-course-plan.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/certifications/[certificationSlug]/recommended-course-plan"])
      });
    }
  